import styled from "styled-components";
import { BADI_COLORS, unitizedPx } from "@badi/badi-components";

export const VisitDetailsWrapper = styled.div`
  background-color: ${BADI_COLORS.ADDITIONAL.ADDITIONAL_07};
  padding: ${unitizedPx(2)};
`;
